module.exports = __webpack_public_path__ + "static/media/banner_branding.3162cf49.png";